import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';
import { sendStreamingMessage } from '../util/streamResponse';
import { LocalStorageService } from './LocalStorageService';

export class AnthropicService extends ApiService {
  static pathName = '/anthropic';

  static response = (
    body: any,
    type: string,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/${type}`, body);
  };

  static reasoningStream = async (body: any): Promise<IGetOneResponse<any>> => {
    try {
      const accessToken = LocalStorageService.getItem('accessToken');
      const baseUrl = process.env.REACT_APP_API_URL;

      const response = await fetch(
        `${baseUrl}${this.pathName}/claude-reasoning`,
        {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            Accept: 'text/event-stream',
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message);
      }

      const { message, thinking, usedTokens } = await sendStreamingMessage(
        response,
      );

      return { data: { message, logs: thinking, usedTokens }, status: '200' };
    } catch (error) {
      throw error;
    }
  };

  static anthropicVision = (
    query: {
      prompt: string;
      flowId: string;
      url?: string;
    },
    body: any,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/vision`, body, query);
  };
}
